import { makeObservable } from "mobx";
import { ShopGoodStore } from "../shop-good";
import { BaseStore } from "../../common";
import { ShopGood } from "../../../interfaces";

export class ShopGoodsStore extends BaseStore<ShopGood, typeof ShopGoodStore> {
	PATH = "shop/goods";

	constructor() {
		super(ShopGoodStore);
		makeObservable(this);
	}
}
